import { render, staticRenderFns } from "./process.vue?vue&type=template&id=4827c62f&scoped=true&"
import script from "./process.vue?vue&type=script&lang=js&"
export * from "./process.vue?vue&type=script&lang=js&"
import style0 from "./process.vue?vue&type=style&index=0&id=4827c62f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4827c62f",
  null
  
)

export default component.exports